import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const careersFields: FieldInterface[] = [
  {
    key: 'ris_data',
    originKey: 'ris_data',
    type: FIELD_TYPES.object,
  },
]

const careersRelations: RelationInterface[] = []

export { careersFields, careersRelations }
